// extracted by mini-css-extract-plugin
export var aiPolicy = "c_l";
export var icon = "c_j";
export var prevSection = "c_h";
export var rowGap = "c_m";
export var section = "c_d";
export var separator = "c_f";
export var table = "c_c";